<template>
  <div>
    <!-- ページヘッダー -->
    <div class="container-fluid page-head-wrap">
      <div class="container page-head">
        <h3 class="h4 text-center">
          <router-link :to="{ name: 'mypage::order::history', params: {} }">
          <i class="fa fa-chevron-left back-icon" aria-hidden="true"></i>
          </router-link>
          <b><trans-text i18nKey="ui['5_4'][16]" /></b>
        </h3>
      </div>
    </div>
    <div class="container-fluid page-head-wrap" v-if="apiLoading ||(isMobileBreakpoint && !isDesktop)">
      <div class="container page-head text-center">
        <p class=" questionnaire-subhead mb-0 d-inline-block" v-if="isMobileBreakpoint && !isDesktop"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> <trans-text i18nKey="ui['5_4_1'][7]"/></p>
        <p class="mb-0" v-if="apiLoading"><i class="fa fa-spinner fa-pulse fa-fw" style="font-size: 14px; "></i> <trans-text i18nKey="ui['5_4_1'][101]"/></p>
      </div>
    </div>
    <div class="container">

      <!-- 画面遷移UI -->
      <div class="row text-center" v-if="!isMobileBreakpoint">
        <div class="offset-1 offset-sm-2 offset-md-4 col-10 col-sm-8 col-md-4">
          <div class="my-4">
            <button tag="button" class="btn w-100 btn-warning" @click="donwloadAllImage"><trans-text i18nKey="ui['5_4_1'][6]"/></button>
          </div>
        </div>
      </div>

      <div class="row">
        <template v-for="orderEvent of order.order_events">
          <div class="col-lg-12">

            <div class="row no-gutters event-info mt-3">
              <div class="col-lg-4">
                <div class="d-flex flex-row h-100">
                  <div class="info-label w-25"><trans-text i18nKey="ui['5_4_1'][1]" /></div>
                  <div class="info-value flex-grow-1">{{orderEvent.event.name}}</div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="d-flex flex-row">
                  <div class="info-label w-25 h-100"><trans-text i18nKey="ui['5_4_1'][2]" /></div>
                  <div class="info-value flex-grow-1"><trans-text i18nKey="ui['91'][2]" /></div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="d-flex flex-row h-100">
                  <div class="info-label w-25"><trans-text i18nKey="ui['5_4_1'][4]" /></div>
                  <div class="info-value flex-grow-1">{{orderEvent.event.end_date_disp}}</div>
                </div>
              </div>
            </div>

            <!-- 写真一覧 -->
            <div class="row mx-1-gutters mt-2">
              <component :is="photoComponent(orderPhoto)" :orderPhoto="orderPhoto" v-for="orderPhoto in orderEvent.order_photos" :key="orderPhoto.id"
              :ref="'photoComponent_' + orderPhoto.id" @showPhotoImageModal="showPhotoImageModal" :isDesktop="isDesktop">
              </component>
            </div>
          </div>
        </template>
        <!-- 画像拡大表示モーダル -->
        <order-download-photo-image-modal :targetPhoto="targetPhoto" :targetPhotoSize="targetPhotoSize"
                           @prevImage="prevImage" @nextImage="nextImage"
                           :key="targetPhotoKey" :isDesktop="isDesktop" ref="zoomModal">
        </order-download-photo-image-modal>
      </div>
    </div>
  </div>

</template>

<script>
  /* util */
  import {dd,store,app} from 'systems/imports'
  import PageContent from 'page/partials/MyPage/Order/Download/PageContent.vue'
  import Order from 'processor/Order'
  import Util from 'processor/Util'
  /* child */
  import GroupHorizonPhoto from 'page/partials/MyPage/Order/Download/GroupHorizonPhoto.vue'
  import SnapHorizonPhoto from 'page/partials/MyPage/Order/Download/SnapHorizonPhoto.vue'
  import SnapVerticalPhoto from 'page/partials/MyPage/Order/Download/SnapVerticalPhoto.vue'
  /* modal */
  import OrderDownloadPhotoImageModal from 'components/modal/OrderDownloadPhotoImageModal.vue'

  /** @see page_subPages_MyPage_Order parent page */
  /** @name page_subPages_MyPage_Order_Download */
  export default {
    name:"",
    components: {
      PageContent,
      GroupHorizonPhoto,
      SnapHorizonPhoto,
      SnapVerticalPhoto,
      OrderDownloadPhotoImageModal,
    },
    data () {
      return {
        order:{},
        targetPhoto:{},
        targetPhotoSize:{},
        isDesktop:false,
        apiLoading:true,
      }
    },
    mounted(){
      Util.userAgent({})
        .then((res) => {
          if (res.status === "ng") {
            this.apiErrorI18nKeyByViewingEvent = res.apiErrorI18nKey
            return
          }
          this.isDesktop = res.data.is_desktop
        })
      Order.findOrder({order_id: this.$route.params.order_id})
        .then((res) => {
          if (res.status === "ng") {
            this.apiErrorI18nKeyByViewingEvent = res.apiErrorI18nKey
            return
          }
          this.order = res.data.order
          this.apiLoading = false
          this.$nextTick(()=> {
            setTimeout(()=>{
              this.$Lazyload.lazyLoadHandler()
            },50)
          })
        })
    },
    computed:{
      isMobileBreakpoint(){
        switch(this.$root.bootstrapBreakpoint){
          case "xl":
          case "lg":
            return false
          case "md":
          case "sm":
          case "xs":
            return true
          default:
            return null
        }
      },
      targetPhotoKey(){
        let targetPhoto = targetPhoto
        if(!targetPhoto){return null}
        return targetPhoto.id
      },
      filteredPhotos(){
        let order = this.order
        if(!order){ return []}

        let rets = []

        app.make("_").each(order.order_events,(order_event)=>{
          app.make("_").each(order_event.order_photos,(order_photo)=>{
            rets.push(order_photo.original_photo)
          })
        })
        return rets
      },
    },
    methods:{
      donwloadAllImage(){
          location.href = this.order.all_image_download_url + '?token='+store.get("token")
      },
      showPhotoImageModal(photo,photoSize){
        this.targetPhoto = photo
        this.targetPhotoSize = photoSize

        let isVertically = app.make("_").first(this.targetPhoto.photo_thumbnails).is_vertically
        let photoTypeCode = app.make("_").first(this.targetPhoto.photo_types).code

        this.$nextTick(function () {
          $(this.$refs.zoomModal.$refs.modal).modal({})
        })
      },
      prevImage(photo){
        let photoIndex = app.make("_").findIndex(this.filteredPhotos, function(o) { return o.id == photo.id; })
        photoIndex--;
        if(photoIndex<0){ photoIndex = (this.filteredPhotos.length - 1)}
        this.targetPhoto = this.filteredPhotos[photoIndex]


        let photoSize = {}
        app.make("_").each(this.order.order_events,(order_event)=>{
          app.make("_").each(order_event.order_photos,(order_photo)=>{
            if(order_photo.original_photo.id === this.targetPhoto.id  ){
              photoSize = order_photo.photo_size
            }
          })
        })
        this.targetPhotoSize = photoSize

      },
      nextImage(photo){
        let photoIndex = app.make("_").findIndex(this.filteredPhotos, function(o) { return o.id == photo.id; })
        photoIndex++;
        if(photoIndex>=this.filteredPhotos.length){ photoIndex = 0 }
        this.targetPhoto = this.filteredPhotos[photoIndex]
        //dd("A",this.targetPhoto)

        let photoSize = {}
        app.make("_").each(this.order.order_events,(order_event)=>{
          app.make("_").each(order_event.order_photos,(order_photo)=>{
            if(order_photo.original_photo.id === this.targetPhoto.id  ){
              photoSize = order_photo.photo_size
            }
          })
        })
        this.targetPhotoSize = photoSize

      },
      photoComponent(orderPhoto){
        let photo = orderPhoto.original_photo || {}
        //dd("A",photo)
        if (!photo.id) {
          return
        }
        let photoTypeCode = app.make("_").first(photo.photo_types).code
        let isVertically = app.make("_").first(photo.photo_thumbnails).is_vertically

        switch (String(photoTypeCode)) {
          case "1": //スナップ
            return isVertically ? "SnapVerticalPhoto" : "SnapHorizonPhoto"
          case "2": //集合写真
            return isVertically ? "SnapVerticalPhoto" : "GroupHorizonPhoto"
        }
      }
    }
  }
</script>


<style lang="scss" scoped>
  .event-info{
    background-color: #fff;
    border-top: 1px solid #82ba1d;
    border-left: 1px solid #82ba1d;
    font-size: .8rem;
    .info-label{
      text-align: center;
      padding: .1rem .2rem;
      border-right: 1px solid #82ba1d;
      border-bottom: 1px solid #82ba1d;
      color: #82ba1d;
    }
    .info-value{
      padding: .1rem .2rem;
      border-right: 1px solid #82ba1d;
      border-bottom: 1px solid #82ba1d;
    }
  }
  .questionnaire-subhead{
    padding:.1rem 1rem;
    font-size: 1.2rem;
    border: 1px solid #000;
    background-color: #ffffc1;
  }
</style>



// WEBPACK FOOTER //
// Download.vue?1b17bcff